// extracted by mini-css-extract-plugin
module.exports = {"posts":"styles_posts__wcpEF","items":"styles_items__1ARUD","empty":"styles_empty__28SL6"};